// extracted by mini-css-extract-plugin
export default {"title-img":"Header_title-img__uhCxh"};